import { withPrefix } from 'gatsby'

const fontUrl = (name: string) => withPrefix(`/fonts/${name}.woff2`)

// Fallback whose metrics are overridden to PxGrotesk's so the swap doesn't
// reflow. Overrides are PxGrotesk's hhea metrics; size-adjust is per-face,
// measured against real Arial.
const fallbackFace = (family: string, sizeAdjust: string) => `
@font-face {
  font-family: '${family}';
  src: local('Helvetica Neue'), local('Arial'), local('Liberation Sans');
  size-adjust: ${sizeAdjust};
  ascent-override: 113.4%;
  descent-override: 28%;
  line-gap-override: 0%;
}`

export const fontFace = `
@font-face {
  font-family: 'PxGroteskRegular';
  src: url(${fontUrl('PxGroteskRegular')}) format('woff2');
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PxGroteskScreen';
  src: url(${fontUrl('PxGroteskScreen')}) format('woff2');
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PxGroteskBold';
  src: url(${fontUrl('PxGroteskBold')}) format('woff2');
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PxGroteskBoldItalic';
  src: url(${fontUrl('PxGroteskBoldItalic')}) format('woff2');
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}

/*
  Register the Bold, Italic, and BoldItalic faces as weights/styles of the
  PxGroteskRegular family so font-weight: bold, font-style: italic, and
  <strong>/<b>/<em> render the DESIGNED faces instead of synthetic (faux) bold
  or oblique. Bold/BoldItalic reuse the standalone .woff2 files (deduped on
  download); the regular italic is Optimo's Px Grotesk Regular Italic, with its
  vertical metrics normalized to this cut (see static/fonts).
*/
@font-face {
  font-family: 'PxGroteskRegular';
  src: url(${fontUrl('PxGroteskBold')}) format('woff2');
  font-style: normal;
  font-weight: bold;
  font-display: swap;
}

@font-face {
  font-family: 'PxGroteskRegular';
  src: url(${fontUrl('PxGroteskRegularItalic')}) format('woff2');
  font-style: italic;
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PxGroteskRegular';
  src: url(${fontUrl('PxGroteskBoldItalic')}) format('woff2');
  font-style: italic;
  font-weight: bold;
  font-display: swap;
}
${fallbackFace('PxGrotesk Fallback', '105%')}
${fallbackFace('PxGrotesk Screen Fallback', '111%')}
${fallbackFace('PxGrotesk Bold Fallback', '110%')}
`
